import React from 'react'
import { connect } from "react-redux";
import { SetCopyKey } from '$Deposits/store/actions/DepositAction'
import { GetParamsData } from '$Deposits/lib/LibCommonData'
import copy from 'copy-to-clipboard';

export class CopyView extends React.Component {

    componentWillUnmount() {
        this.props.SetCopyKey('')
    }

    copys = (txt) => {
        try {
            const value = String(this.props.copyValue)
            copy(value)
            const { toastTip } = GetParamsData()
            toastTip.success('คัดลอกแล้ว')

            this.props.SetCopyKey(this.props.copyType)
        } catch (error) {

        }
    }

    render() {
        const { copyValue, copyTitle, CopyKey, copyType } = this.props
        return (
            <>
                <div className='paymentData'>
                    {
                        copyTitle && <span className='paymentTitle'>{copyTitle}</span>
                    }
                    <div className='paymentItem' onClick={() => { this.copys() }}>
                        {
                            copyType == 'bankName' && <span className='depositBankIcon' />
                        }
                        <span className={`paymentValue ${copyType}`} >{copyType == 'money' || copyType == 'uniqueAmount' ? '฿ ' : ''}{copyValue}</span>
                        <span className='copyIcon' />
                        {
                            CopyKey == copyType && <span className='copyActive' />
                        }
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = state => ({
    CopyKey: state.CopyKey,
});
const mapDispatchToProps = {
    SetCopyKey: (data = '') => SetCopyKey(data),
};
export default connect(mapStateToProps, mapDispatchToProps)(CopyView);
